<template>
    <div>
        <d-contract-esc-edit
            v-model      = "edit"
            :contract-id = "contract ? contract.id : null"
            :company-id  = "contract && contract.company ? contract.company.id : null"
            @saved       = "onSaved"
        />

        <c-list-card
            :icon       = "icon"
            :background = "background"
            :height     = "110"
            @edit       = "onEdit"
            @selected   = "onSelect"
        >
            <template v-slot:title>
                <div>
                    <span class="primary--text">
                        {{ contract.id }} Notruf
                    </span>
                </div>
                <v-spacer></v-spacer>
                <company-tag
                    :label="$t('msd.service.role.esc.label')"
                    :active  ="contract.active"
                    :company = "contract.company"
                    :highlight = "company && contract.company.id === company.id"
                />
            </template>

            <template v-slot:subtitle>
                <div class="primary--text customer-name">
                    {{ contract.customer ? contract.customer.name : ''}}
                </div>
            </template>

            <template v-slot:body>
                <p-contract-condition
                    :contract = "contract"
                />
            </template>

            <template v-slot:footer>

            </template>
        </c-list-card>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import CListCard from "@/modules/core/components/utils/CListCard";
import CompanyTag from "@/modules/msd/company/common/components/controlls/CompanyTag";
import DContractEscEdit from "@/modules/msd/company/contract/components/controls/esc/DContractEscEdit";
import PContractCondition from "@/modules/msd/company/contract/components/controls/common/PContractCondition.vue";

export default {
    name: "CContractEscCard",
    components: {
        PContractCondition,
        DContractEscEdit,
        CompanyTag,
        CListCard,
    },

    props: {
        contract: {

        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        company: {

        }
    },

    data: () => ({
        edit: false,
    }),

    computed: {
        icon () {
            return {
                label : "N",
                active: this.contract.active,
            }
        },
    },

    methods: {
        onSelect () {
            if (!this.contract.active) {
                return;
            }
            console.log(this.contract)
            Core.fire.selected(this, this.contract);
        },

        onEdit () {
            this.edit = true;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        },

        toHtml (text) {
            return Core.format.html(text);
        },

        money (value) {
            if (!value) {
                return "---"
            }
            return Core.format.money(value);
        },

        date (value) {
            return Core.format.date.sdisplay(value);
        },
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .v-card--link:focus:before {
    opacity: 0.0!important;
}


</style>